module.exports = __webpack_public_path__ + "static/img/kaineng1.3894c898.webp";